/*
* These helpers are intended to be used within try/catch blocks to ensure that these blocks are
* only handling exceptions they are intended to handle and are not swallowing errors that should
* be allowed to continue propagating up the call stack.
*
* This is surprisingly difficult to do as most errors are simply instances of the base Error object
* and these errors must be distinguished by other means -- usually testing for the presence of
* specific properties or message contents.
 */


/*
* Axios Errors
* See: https://github.com/axios/axios#handling-errors
 */
export const isAxiosRequestError = (error) => {
  return !!error.request;
};


export const isAxiosResponseError = (error) => {
  return !!error.response;
};


export const isAxiosError = (error) => {
  return isAxiosRequestError(error) || isAxiosResponseError(error);
};


/*
* Fetch Errors
* See: https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch
* > "Checking that the fetch was successful"
 */
export const isFetchNetworkError = (error) => {
  if (!(error instanceof TypeError)) {
    return false;
  }

  // NOTE: I hope browsers are consistent on this message ...
  return error.message === 'Failed to fetch';
};


/*
* Apollo Errors
* See: https://github.com/apollographql/apollo-client/blob/master/packages/apollo-client/src/errors/ApolloError.ts
 */
export const isApolloGraphQLError = (error) => {
  return !!error.graphQLErrors;
};


export const isApolloNetworkError = (error) => {
  return !!error.networkError;
};


export const isApolloError = (error) => {
  return isApolloGraphQLError(error) || isApolloNetworkError(error);
};
